<div class="animated fadeInDown DocumentContainer" *ngIf="showPurchaseContractVisualizer">

    <div class="PopUpTitleContainer">
      <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentPurchaseContract.ID == null && !DocumentBodyLoading;">
        <span *ngIf="!IsStorno;">{{ 'PurchaseContracts.NewPurchaseContract' | translate }}</span>
        <span *ngIf="IsStorno;">{{ 'PurchaseContracts.StornoPurchaseContract' | translate }}</span>
        </p>
        <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentPurchaseContract.ID != null && !DocumentBodyLoading;">
          <span>
            {{CurrentPurchaseContract.AccountingNumber.AccountingSeries.Series}} 
            {{(CurrentPurchaseContract.AccountingNumber.Number)}} 
            / {{CurrentPurchaseContract.EventRegisterUI}}
          </span>
        </p>
     </div> 
  
     <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
      <button mat-raised-button color="primary" class="VizualizeCommandButton" (click)="ExportPurchaseContract(this.CurrentPurchaseContract);" style="outline: none;">
        <i class="material-icons">file_copy</i>
        <span>{{ 'PurchaseContracts.Document.Export' | translate }}</span>
      </button>
  
      <button mat-raised-button class="VizualizeCommandButton" (click)="PrintPurchaseContract(this.CurrentPurchaseContract);" style="outline: none;">
        <i class="material-icons">print</i>
        <span>{{ 'PurchaseContracts.Document.Print' | translate }}</span>
      </button>
  
      <button mat-raised-button color="primary" class="VizualizeCommandButton" style="outline: none;float: right;background: #32aa3a;" (click)="this.parent.RedirectToURL('dashboard/documents/purchasecontracts');">
        <i class="material-icons">check</i>
        <span>{{ 'PurchaseContracts.BackToPurchaseContractsMenu' | translate }}</span>
      </button>

      <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(this.CurrentPurchaseContract);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
        <i class="material-icons">print</i>
        <span>{{ 'AutoPrint' | translate }}</span>
      </button>
  
      <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
    </div>
  
     <div class="PopUpBody" style="max-height: 75vh;" *ngIf="!CurrentPurchaseContract.IsStorno">
       <div class="DocumentBody">
  
        <p class="DocumentBodyCanceled" *ngIf="CurrentPurchaseContract.DocumentStatus.ID == -1;">anulata</p>
  
         <div style="border: solid 1px #333;">
          
          <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
            <tbody>
              <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
                <td>{{ 'PurchaseContracts.Document.Title' | translate }}</td>
              </tr>
  
              <table style="width: 100%;margin-top: 25px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.DocNr' | translate }}:  {{CurrentPurchaseContract.AccountingNumber.AccountingSeries.Series}}{{(CurrentPurchaseContract.AccountingNumber.Number)}}</td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Administrations' | translate }}: 
                      <span *ngFor="let a of this.CurrentPurchaseContract.Administrations; let i=index;">{{a.Name}}; </span>
                    </td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.Date' | translate }}: {{CurrentPurchaseContract.EventRegisterUI}}</td>
                  </tr>
                </tbody>
              </table>
             
            </tbody>
          </table>
  
          <table style="width: 100%;border-bottom: solid 1px #333;">
            <tbody>
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.UndersignedTitle' | translate }} {{this.CurrentPurchaseContract.Supplier.Name}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.SupplyingDocuments' | translate }}: {{this.CurrentPurchaseContract.DocumentNumber}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.Delegate' | translate }}: {{this.CurrentPurchaseContract.Details.Delegate}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.Observations' | translate }}: {{this.CurrentPurchaseContract.Details.Observations}}
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <table style="width: 100%;margin-top: 5px;margin-bottom: 20px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.Auto' | translate }}: {{this.CurrentPurchaseContract.Details.Auto}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
            </tbody>
          </table>
  
          <table style="width: 100%;">
            <tbody>
              
              <table style="width: 100%;font-size: 12px;">
                <tbody>
                  <tr style="width: 100%;">
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Nr' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Name' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.MU' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'PurchaseContracts.Document.Table.DocQuantity' | translate }}</td>
                        </tr>
                      </tbody>
                      </table>
                    </td>
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
  
                        <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                            <tbody>
                              <tr>
                                <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'PurchaseContracts.Document.Table.Received' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>
  
                        <tr>
                          <td style="padding: 0;">
                            <table style="width: 100%;height: 35px;padding: 0;">
                              <tbody>
                                <tr>
                                  <td style="text-align: center;width: 15%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Quantity' | translate }}</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.UnitPrice' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.TotalValue' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 25%;padding: 0;">{{ 'PurchaseContracts.Document.Table.VATValue' | translate }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          </tr>
  
                      </tbody>
                      </table>
                    </td>
  
                  </tr>
  
                  <tr style="width: 100%;">
  
                   <td style="padding: 0;">
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentPurchaseContract.Products; let i=index;">
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{i + 1}}
                          </td>
              
                          <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            ({{p.ProductPurchaseContractInfo.Code}}) {{p.ProductPurchaseContractInfo.Name}}
                          </td>
              
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.MeasuringUnit.Name}}
                          </td>
              
                          <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.DocQuantity}}
                          </td>
              
                          <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Quantity}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIUnitPrice}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIQtyPrice}}
                          </td>
              
                          <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.TotalVATValue}}
                          </td>
                        </tr>
                      </tbody>
                      </table>
                   </td>
  
                  </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.TotalNOVAT' | translate }}:
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.VATValue' | translate }}:
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{ 'PurchaseContracts.Document.Table.Total' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceNOVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.PurchaseContractCommitee' | translate }}: {{CurrentPurchaseContract.Details.PurchaseContractCommittee}}
                           </td>
               
                           <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.ReceivedInAdministration' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
               
                           <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                             
                           </td>
               
                           <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{CurrentPurchaseContract.UpdatingUser.UserName}}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Currency' | translate }}: {{CurrentPurchaseContract.Details.CurrencyRow}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                </tbody>
              </table>
  
            </tbody>
          </table>
  
         </div>
  
       </div>
     </div>
  
     <div class="PopUpBody" style="max-height: 75vh;" *ngIf="CurrentPurchaseContract.IsStorno">
      <div class="DocumentBody">
  
       <p class="DocumentBodyCanceled" *ngIf="CurrentPurchaseContract.DocumentStatus.ID == -1;">anulata</p>
  
        <div style="border: solid 1px #333;">
          <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
            <tbody>
              <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
                <td>{{ 'PurchaseContracts.Document.DocumentStorno.ReturnTitle' | translate }}</td>
              </tr>
  
              <table style="width: 100%;margin-top: 25px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.DocNr' | translate }}:  {{CurrentPurchaseContract.AccountingNumber.AccountingSeries.Series}}{{(CurrentPurchaseContract.AccountingNumber.Number)}}</td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Administrations' | translate }}: 
                      <span *ngFor="let a of this.CurrentPurchaseContract.Administrations; let i=index;">{{a.Name}}; </span>
                    </td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.Date' | translate }}: {{CurrentPurchaseContract.EventRegisterUI}}</td>
                  </tr>
                </tbody>
              </table>
             
            </tbody>
          </table>
  
          <table style="width: 100%;border-bottom: solid 1px #333;">
  
            <tbody>
              <table style="width: 100%;margin-top: 5px;margin-bottom: 25px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.DocumentStorno.ReturnSubTitle' | translate }} {{this.CurrentPurchaseContract.Supplier.Name}} 
                      {{ 'PurchaseContracts.Document.DocumentStorno.OnDocumentBasis' | translate }} {{CurrentPurchaseContract.DocumentNumber}} / {{CurrentPurchaseContract.DocumentDate}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </tbody>
  
          </table>
  
          <table style="width: 100%;">
            <tbody>
              
              <table style="width: 100%;font-size: 12px;">
                <tbody>
                  <tr style="width: 100%;">
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Nr' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Name' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.MU' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'PurchaseContracts.Document.Table.DocQuantity' | translate }}</td>
                        </tr>
                      </tbody>
                      </table>
                    </td>
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
  
                        <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                            <tbody>
                              <tr>
                                <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'PurchaseContracts.Document.Table.Returned' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>
  
                        <tr>
                          <td style="padding: 0;">
                            <table style="width: 100%;height: 35px;padding: 0;">
                              <tbody>
                                <tr>
                                  <td style="text-align: center;width: 15%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Quantity' | translate }}</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.UnitPrice' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.TotalValue' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 25%;padding: 0;">{{ 'PurchaseContracts.Document.Table.VATValue' | translate }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          </tr>
  
                      </tbody>
                      </table>
                    </td>
  
                  </tr>
  
                  <tr style="width: 100%;">
  
                   <td style="padding: 0;">
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentPurchaseContract.Products; let i=index;">
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{i + 1}}
                          </td>
              
                          <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            ({{p.ProductPurchaseContractInfo.Code}}) {{p.ProductPurchaseContractInfo.Name}}
                          </td>
              
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.MeasuringUnit.Name}}
                          </td>
              
                          <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.DocQuantity}}
                          </td>
              
                          <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Quantity}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIUnitPrice}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIQtyPrice}}
                          </td>
              
                          <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{p.ProductPurchaseContractInfo.TotalVATValue}}
                          </td>
                        </tr>
                      </tbody>
                      </table>
                   </td>
  
                  </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.TotalNOVAT' | translate }}:
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.VATValue' | translate }}:
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{ 'PurchaseContracts.Document.Table.Total' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceNOVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.PurchaseContractCommitee' | translate }}: {{CurrentPurchaseContract.Details.PurchaseContractCommittee}}
                           </td>
               
                           <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.ReceivedInAdministration' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
               
                           <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                             
                           </td>
               
                           <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{CurrentPurchaseContract.UpdatingUser.UserName}}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Currency' | translate }}: {{CurrentPurchaseContract.Details.CurrencyRow}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                </tbody>
              </table>
  
            </tbody>
          </table>
        </div>
  
      </div>
    </div>
  </div>
  
  <div class="MainContainer animated fadeIn">
  
    <div class="InfoQuestion animated fadeInDown" *ngIf="showAccountingSeriesError">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.AccountingSeriesDocumentError' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.AccountingSeriesDocumentErrorDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button mat-raised-button color="primary" class="InfoQuestionButton" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"> {{ 'Configuration.GoToSettings' | translate }}</button>
      </div>
    </div>
  
      <div class="overlay" *ngIf="DeleteFileQuestion || ShowDocumentError || ShowProductTaxDivisionContainer || showProductDiscountContainer || showAddNewPartnerPopUp || showEditPartnerPopUp || ShowPurchaseContractEditProductContainer || this.parent.loading  || this.parent.initialLoad || showDocumentDiscountContainer || showPurchaseContractVisualizer;"></div>
      <div class="overlay" *ngIf="showAccountingSeriesError;" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"></div>
  
      <div class="InfoQuestion animated fadeInDown" *ngIf="DeleteFileQuestion">
        <div class="InfoQuestionClose">
          <i class="material-icons" (click)="DeleteFileQuestion = false;">close</i>
        </div>
        <div class="InfoQuestionTitle">
          {{ 'Configuration.DeleteQuestion' | translate }}
        </div>
        <div class="InfoQuestionBody">
          {{ 'Configuration.DeleteQuestionDescription' | translate }}
        </div>
  
        <div class="InfoQuestionCommands">
          <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="DeleteFileQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteFileQuestion = false;DeleteFile(this.CurrentPurchaseContract.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
        </div>
      </div>

      <div class="animated fadeInDown PurchaseContractEditProductContainer" *ngIf="ShowProductTaxDivisionContainer">
        <div class="PopUpCloseContainer" (click)="ShowProductTaxDivisionContainer = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PurchaseContractEditProductTitleContainer">
         <p>{{ 'PurchaseContracts.ConsumeTax' | translate }} - {{this.CurrentProduct.ProductPurchaseContractInfo.Name}}</p>
        </div>
  
        <div class="PopUpBody">
          <div class="PopUpBodyRow" style="min-height: 50px;padding-top: 10px;padding-left: 1%;">
            <mat-radio-group (change)="RadioChangeTaxDivisionType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
              <mat-radio-button [checked]="type.ID === this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.TaxDivisionType.ID" [value]="type" class="LangRadio" *ngFor="let type of this.TaxDivisionTypes; index as i">{{type.Name}}</mat-radio-button>
            </mat-radio-group>
          </div>
  
          <div class="PopUpBodyRow" style="min-height: 50px;padding-top: 10px;padding-left: 1%;">
            {{this.CurrentProduct.ProductPurchaseContractInfo.Name}} ({{this.CurrentProduct.ProductPurchaseContractInfo.Code}})
          </div>
  
          <div class="PopUpBodyRow" *ngIf="IsLoadingTaxDivision">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>
          
          <div *ngIf="!IsLoadingTaxDivision">
            <div class="PurchaseContractProductsHeadder PurchaseContractProductsRow" style="border: none;">
              <div class="PurchaseContractProductsCol">
                  {{ 'PurchaseContracts.Table.Nr' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                  {{ 'PurchaseContracts.Administration' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                  {{ 'PurchaseContracts.Table.Name' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{ 'PurchaseContracts.Table.Code' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{ 'PurchaseContracts.Table.MU' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{ 'PurchaseContracts.Table.Qty' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{ 'PurchaseContracts.Table.DocQty' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 20%;">
                Procent repartizare
              </div>
              <div class="PurchaseContractProductsCol" style="width: 15%;">
                Valoare repartizata
              </div>
          </div>
    
            <div class="PurchaseContractProductsRow PurchaseContractProductsRowHover" *ngFor="let p of this.Products; let i=index;">
            <div *ngIf="p.ProductPurchaseContractInfo.GeneralType.ID == 1;">
              <div class="PurchaseContractProductsCol">
                {{i + 1}}
            </div>
            <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{p.ProductPurchaseContractInfo.Administration.Name}}
            </div>
            <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
              <p>{{p.ProductPurchaseContractInfo.Name}}</p>
            </div>
            <div class="PurchaseContractProductsCol" style="width: 7.5%;">
              {{p.ProductPurchaseContractInfo.Code}}
              <p class="PurchaseContractProductsColDesc">{{p.ProductPurchaseContractInfo.GeneralType.Name}}</p>
            </div>
            <div class="PurchaseContractProductsCol" style="width: 7.5%;">
              {{p.ProductPurchaseContractInfo.MeasuringUnit.Name}}
            </div>
            <div class="PurchaseContractProductsCol" style="width: 7.5%;">
              {{p.ProductPurchaseContractInfo.Quantity}}
            </div>
            <div class="PurchaseContractProductsCol" style="width: 7.5%;">
              {{p.ProductPurchaseContractInfo.DocQuantity}}
            </div>
            <div class="PurchaseContractProductsCol" style="width: 20%;">
              {{p.ProductPurchaseContractInfo.TaxDistribution.Percentage}}%
            </div>
              <div class="PurchaseContractProductsCol" style="width: 15%;">
                {{p.ProductPurchaseContractInfo.TaxDistribution.QtyValue}}
              </div>
              </div>
            </div>
          </div>
  
        </div>
  
        <div class="PopUpCommands">
          <button mat-raised-button color="primary" class="PurchaseContractEditProductSaveButton" (click)="SubmitTaxProductDistribution();">
            <i class="material-icons">read_more</i>
            {{ 'PurchaseContracts.ConsumeTax' | translate }}
          </button>
          <button mat-raised-button color="warn" class="PurchaseContractEditProductSaveButton" (click)="CancelTaxProductDistribution();" *ngIf="this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.IsTaxConsumed == true;">
            <i class="material-icons">close</i>
            {{ 'PurchaseContracts.CancelTaxDistribution' | translate }}
          </button>
        </div>
  
      </div>
  
      <div class="animated fadeInDown PurchaseContractEditProductContainer" *ngIf="ShowPurchaseContractEditProductContainer">
        <div class="PopUpCloseContainer" (click)="ShowPurchaseContractEditProductContainer = false;RevertProduct();">
          <i class="material-icons">close</i>
        </div>
        <div class="PurchaseContractEditProductTitleContainer">
         <p>
          <i class="material-icons titleModificationIcon">build</i>
           {{CurrentProduct.ProductPurchaseContractInfo.Name}}
          </p>
        </div>
  
        <div class="PopUpBody" *ngIf="!loadingEditProduct">
          <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID == null;">
            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                <mat-label>{{ 'PurchaseContracts.Administration' | translate }}</mat-label>
                <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Administration">
                  <mat-option *ngFor="let a of this.Administrations;" [value]="a">
                    {{a.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.GeneralType">
                  <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
          </div>
  
          <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID != null;">
            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Administration' | translate }}</mat-label>
                <input disabled="disabled" matInput placeholder="{{ 'PurchaseContracts.Administration' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Administration.Name">
              </mat-form-field>
            </div>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                <input disabled="disabled" matInput placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.GeneralType.Name">
              </mat-form-field>
            </div>
  
          </div>
         
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.Name' | translate }}</mat-label>
                <input matInput placeholder="{{ 'PurchaseContracts.Table.Name' | translate }}" autocomplete="off" (click)="SearchProductsPurchaseContractInformation(CurrentProduct.ProductPurchaseContractInfo.Name, CurrentProduct.ProductPurchaseContractInfo.Administration.ID, true); showhideSearches(true);" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsPurchaseContractInformation(CurrentProduct.ProductPurchaseContractInfo.Name, CurrentProduct.ProductPurchaseContractInfo.Administration.ID, true);">
                <mat-icon matSuffix style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNTPop == 0 && !loadingSearchProducts && CurrentProduct.ProductPurchaseContractInfo.Name.length == 0;">search</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNTPop > 0 || CurrentProduct.ProductPurchaseContractInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</mat-icon>
              </mat-form-field>
              <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
                <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.Code' | translate }}</mat-label>
                <input disabled *ngIf="CurrentProduct.ProductPurchaseContractInfo.ProductID != null;" matInput placeholder="{{ 'PurchaseContracts.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Code">
                <input *ngIf="CurrentProduct.ProductPurchaseContractInfo.ProductID == null;" matInput placeholder="{{ 'PurchaseContracts.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Code">
              </mat-form-field>
            </div>
            <div class="ProductsSearchResultsContainer ProductsSearchResultsContainerPopException" *ngIf="ProductsSearchResultsCOUNTPop > 0 && this.showSearchCurrent == true;">
              <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResultsPop" (click)="SelectPurchaseContractProductFromSearchCurrent(p);">
                  <p class="ProductSearchResultTitle">{{p.Name}}</p>
              </div>
            </div>
          </div>
  
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                <mat-label>{{ 'PurchaseContracts.Table.MU' | translate }}</mat-label>
                <mat-select name="MeasuringUnit" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.MeasuringUnit">
                  <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u">
                    {{u.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.Qty' | translate }}</mat-label>
                <input matInput placeholder="{{ 'PurchaseContracts.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Quantity">
              </mat-form-field>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.DocQty' | translate }}</mat-label>
                <input matInput placeholder="{{ 'PurchaseContracts.Table.DocQty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.DocQuantity">
              </mat-form-field>
            </div>
          </div>
  
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.PriceNOVAT' | translate }}</mat-label>
                <input [disabled]="CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT" matInput placeholder="{{ 'PurchaseContracts.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.UIUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductPurchaseContractInfo.Price.UIUnitPrice);">
              </mat-form-field>
            </div>
  
             <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.PriceVAT' | translate }}</mat-label>
                <input [disabled]="!CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT" matInput placeholder="{{ 'PurchaseContracts.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice);">
              </mat-form-field>
            </div>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                <mat-label>{{ 'PurchaseContracts.Table.VAT' | translate }}</mat-label>
                <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.VAT">
                  <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="ModifyPurchaseContractProduct(true);">
                    {{v.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          
          </div>
  
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <mat-slide-toggle (change)="priceContainsVATchanged($event)" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT">{{ 'PurchaseContracts.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
            </div>
          </div>
  
          <div class="DiscountRow" *ngIf="CurrentProduct.ProductPurchaseContractInfo.Price.Discount != null && CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Value != null && CurrentPurchaseContract.Total.Discount.Value == null;">
  
            <p class="DiscountRowTitle">
              {{CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Type.Name}} Discount - {{CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Value}}
              <span *ngIf="CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Type.ID == 1;">%</span>
              <span> ({{currency.Name}})</span>
            </p>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.PriceNOVAT' | translate }}</mat-label>
                <input [disabled]="true" matInput placeholder="{{ 'PurchaseContracts.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.UIUnitPriceDiscount">
              </mat-form-field>
            </div>
  
             <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="PurchaseContractProductsColSearch">
                <mat-label>{{ 'PurchaseContracts.Table.PriceVAT' | translate }}</mat-label>
                <input [disabled]="true" matInput placeholder="{{ 'PurchaseContracts.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.UIVATUnitPriceDiscount">
              </mat-form-field>
            </div>
  
              <div class="PopUpBodyRowContainer">
               <button mat-button color="warn" (click)="EliminateProductDiscount();">
                <i class="material-icons buttonIcon">close</i>
                {{ 'PurchaseContracts.EliminateDiscount' | translate }}
               </button>
              </div>
          </div>
  
        </div>
  
        <div class="PopUpBody" *ngIf="loadingEditProduct">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>
  
        <div class="PopUpCommands">
          <button mat-raised-button color="primary" class="PurchaseContractEditProductSaveButton" (click)="ModifyPurchaseContractProduct();">
            <i class="material-icons buttonIcon">check</i>
            {{'ModifyProduct' | translate}}
          </button>
        </div>
      </div>
  
      <div class="animated fadeInDown DiscountContainer" *ngIf="showProductDiscountContainer">
        <div class="PopUpCloseContainer" (click)="showProductDiscountContainer = false;">
          <i class="material-icons">close</i>
        </div>
      
        <div class="PopUpTitleContainer">
          <p>{{ 'PurchaseContracts.MenuDiscount' | translate }}</p>
         </div>
  
         <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'PurchaseContracts.DiscountType' | translate }}</mat-label>
            <mat-select name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Type">
              <mat-option *ngFor="let d of this.DiscountTypes" [value]="d" (onSelectionChange)="chanveNewProductVALUE($event);">
                {{d.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <!-- <mat-radio-group (change)="RadioChangeDiscountType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Type">
            <mat-radio-button [checked]="d.Name === this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Type.Name" [value]="d" class="LangRadio" *ngFor="let d of this.DiscountTypes; index as i">{{d.Name}}</mat-radio-button>
          </mat-radio-group> -->
  
          <mat-form-field class="example-full-width discountTextBox" appearance="outline">
            <mat-label>{{ 'PurchaseContracts.DiscountValue' | translate }}</mat-label>
            <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
            <input autocomplete="off" [(ngModel)]="CurrentProduct.ProductPurchaseContractInfo.Price.Discount.Value" matInput placeholder="{{ 'PurchaseContracts.DiscountValue' | translate }}">
          </mat-form-field>
  
        </div>
  
         <div class="PopUpCommands">
          <button (click)="ApplyDiscount();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{ 'PurchaseContracts.ApplyDiscount' | translate }}" class="PopGeneralCommandButton">{{ 'PurchaseContracts.ApplyDiscount' | translate }}</button>
        </div>
      </div>
  
      <div class="animated fadeInDown DiscountContainer" *ngIf="showDocumentDiscountContainer">
        <div class="PopUpCloseContainer" (click)="showDocumentDiscountContainer = false;">
          <i class="material-icons">close</i>
        </div>
      
        <div class="PopUpTitleContainer">
          <p>{{ 'PurchaseContracts.DocDiscount' | translate }}</p>
         </div>
  
         <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'PurchaseContracts.DiscountType' | translate }}</mat-label>
            <mat-select name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentPurchaseContract.Total.Discount.Type">
              <mat-option *ngFor="let d of this.DiscountTypes" [value]="d">
                {{d.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="example-full-width discountTextBox" appearance="outline">
            <mat-label>{{ 'PurchaseContracts.DiscountValue' | translate }}</mat-label>
            <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
            <input autocomplete="off" [(ngModel)]="CurrentPurchaseContract.Total.Discount.Value" matInput placeholder="{{ 'PurchaseContracts.DiscountValue' | translate }}">
          </mat-form-field>
  
        </div>
  
         <div class="PopUpCommands">
          <button (click)="ApplyPurchaseContractDiscount();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{ 'PurchaseContracts.ApplyDiscount' | translate }}" class="PopGeneralCommandButton">{{ 'PurchaseContracts.ApplyDiscount' | translate }}</button>
        </div>
      </div>
  
      <div *ngIf="showAddNewPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
          <div class="PopUpCloseContainer" (click)="showAddNewPartnerPopUp = false;">
            <i class="material-icons">close</i>
          </div>
          <div class="PopUpTitleContainer">
           <p>{{ 'Partners.AddNewPartner' | translate }}</p>
          </div>
    
          <div class="PopUpBody">
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
    
            <form [formGroup]="newPartner">
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
                <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
                <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.newPartner, true);" *ngIf="this.newPartner.controls['VAT'].value != null && this.newPartner.controls['VAT'].value.length && this.newPartner.controls['Country'].value != null;">cloud_download</i>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
                <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
              </mat-form-field>
      
              <div class="PopUpBodySemiTextBox">
                <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
              </div>
      
              <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
      
              <div class="PopUpBodySemiTextBox">
                <mat-form-field>
                  <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                  <mat-select [(ngModel)]="newPartnerCountry" name="country" formControlName="Country" [compareWith]="compareFn" required>
                    <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="City">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
              </mat-form-field>

              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'ZipCode' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
              </mat-form-field>
      
              <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}:</p>
      
              <div class="PopUpBodySemiTextBox">
                <mat-form-field>
                  <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                  <mat-select [(ngModel)]="newPartnerBank" name="bank" formControlName="Bank">
                    <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                      {{b.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox" *ngIf="newPartnerBank != null;">
                <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
              </mat-form-field>
      
              <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Login.Email' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
              </mat-form-field>
            </form>
    
          </div>
    
          <div class="PopUpCommands">
            <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="AddNewPartner();">{{'Partners.AddNewPartner' | translate}}</button>
          </div>
        </div>
  
        <div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
          <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
            <i class="material-icons">close</i>
          </div>
          <div class="PopUpTitleContainer">
           <p>{{ 'Partners.EditPartner' | translate }}</p>
          </div>
    
          <div class="PopUpBody">
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
    
            <form [formGroup]="currentPartner">
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
                <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
                <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
                <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
              </mat-form-field>
      
              <div class="PopUpBodySemiTextBox">
                <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
              </div>
      
              <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
      
              <div class="PopUpBodySemiTextBox">
                <mat-form-field>
                  <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                  <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
                    <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
              </mat-form-field>

              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'ZipCode' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
              </mat-form-field>
      
              <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>
      
              <div class="PopUpBodySemiTextBox">
                <mat-form-field>
                  <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                  <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
                    <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                      {{b.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
              </mat-form-field>
      
              <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Login.Email' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
              </mat-form-field>
            </form>
    
          </div>
    
          <div class="PopUpCommands">
            <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">{{'UpdatePartner' | translate}}</button>
          </div>
        </div>
  
      <div class="MainTitleBar" *ngIf="InitialPaymentsRemainingValue != undefined;">
        <div class="TopValueBanner"  [ngClass]="{'CancelledStatusPopUp': InitialPaymentsRemainingValue < 0, 'CollectedStatusPopUp': InitialPaymentsRemainingValue == 0}">
          {{'RemainingValueToBeComplete' | translate}}: <span class="TopValueBannerValue">{{InitialPaymentsRemainingValue}} {{currency.Name}}</span>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentPurchaseContract.ID?.length > 0;">

        <div class="TopValueBanner" style="background: #efdc75;opacity: 0.75;">
          <span style="color: #f60;">{{'ClosedDocumentModificationWarning' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">lightbulb</i>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="SavedPurchaseContract != true;">
          <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 4px #32aa3a;" *ngIf="this.CurrentPurchaseContract.ID == null;">
          <span *ngIf="!IsStorno;">{{ 'PurchaseContracts.NewPurchaseContract' | translate }}</span>
          <span *ngIf="IsStorno;">{{ 'PurchaseContracts.StornoPurchaseContract' | translate }}</span>
          <span class="DocumentMainCurrencyTopValue">{{currency?.Name}}</span>
          </p>
          <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 4px #32aa3a;" *ngIf="this.CurrentPurchaseContract.ID != null;">
            <span *ngIf="!IsStorno">
              {{ 'PurchaseContracts.UpdatePurchaseContract' | translate }} 
            </span>
            <span *ngIf="IsStorno">
              {{ 'PurchaseContracts.ModifyStorno' | translate }} 
            </span>
            <span class="InvoiceDisplayValue">{{this.CurrentPurchaseContract.AccountingNumber.DisplayValue}}</span>
            <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
          </p>
      </div>
  
      <div class="MainBody animated fadeIn" *ngIf="this.parent.initialLoad == false && SavedPurchaseContract != true;">
         
          <div class="NewPurchaseContractBodyRow">
              <div class="PartnerSearchContainer">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                      <mat-label>{{ 'PurchaseContracts.SearchSupplier' | translate }}*</mat-label>
                      <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm='';AdjustCurrencyOnPartnerSeleciton();TestDocumentValidity();">
                      <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;">search</mat-icon>
                      <i class="material-icons addNewPartnerButton" *ngIf="!this.searchTerm" (click)="showAddNewPartnerPopUp = true;initializeAddPartnerForm();">person_add</i>
                      <i class="material-icons addNewPartnerButton" style="color: red;border:none;" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0;">close</i>
                    </mat-form-field>
      
                    <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                      <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm='';AdjustCurrencyOnPartnerSeleciton();TestDocumentValidity();">
                          <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                      </div>
                    </div>
      
                    <div class="PartnerInfoContainer" *ngIf="partner != null">
                      <i class="material-icons PartnerInfoContainerEUVerified" matTooltip="EU Verified" *ngIf="partner.EUVATVerified">verified_user</i>
                      <p class="PartnerInfoTitle">{{partner.Name}} 
                          <i *ngIf="partner.ID != null;" class="material-icons PartnerDeleteIcon" (click)="partner = null;TestDocumentValidity();">close</i>
                          <i *ngIf="partner.ID != null;" class="material-icons PartnerEditIcon" (click)="initializePartnerFormFromObject(partner);">edit</i>
                          <i *ngIf="partner.ID == null;" class="material-icons PartnerEditIcon" (click)="InsertPartnerFromCloud(partner);">cloud_download</i>
                      </p>
                      <span class="PartnerInfoSubTitle" *ngIf="partner.VAT?.length;">{{partner.VAT}} | </span>
                      <span class="PartnerInfoSubTitle" *ngIf="partner.COCRegNumber?.length;">{{partner.COCRegNumber}}</span>
                      <p class="PartnerInfoSubTitle">{{partner.BillingAddress.Country.ShortName}}, {{partner.BillingAddress.StateProvince}}, {{partner.BillingAddress.City}},| {{partner.BillingAddress.AddressLine}}</p>
                    </div>
              </div>
      
              <div class="newPurchaseContractInputContainer" style="width: 30%;">
                  <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.DocumentType' | translate }}</mat-label>
                      <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="CurrentPurchaseContract.DocType">
                        <mat-option *ngFor="let doc of this.DocTypes" [value]="doc">
                          {{doc.Meaning}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                    <mat-form-field style="width: 100%;" appearance="outline" *ngIf="CurrentPurchaseContract.AccountingNumber?.ID == null;">
                      <mat-label>{{ 'PurchaseContracts.Series' | translate }}</mat-label>
                      <mat-select name="Series" [compareWith]="compareFn" [(ngModel)]="CurrentPurchaseContract.AccountingNumber.AccountingSeries">
                        <mat-option *ngFor="let series of this.AccountingSeries" [value]="series">
                          {{series.Series}} (nr.XXXX)
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                    <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="CurrentPurchaseContract.AccountingNumber.ID != null;">
                      <mat-label>{{CurrentPurchaseContract.AccountingNumber.AccountingSeries.Series}} {{(CurrentPurchaseContract.AccountingNumber.Number)}}</mat-label>
                      <input matInput placeholder="Series" autocomplete="off" disabled="true">
                    </mat-form-field>
              </div>
             
              <div class="newPurchaseContractInputContainer">
                  <mat-form-field appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.DocumentDate' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" [formControl]="DocumentDate" [(ngModel)]="CurrentPurchaseContract.DocumentDate" (dateChange)="TestDocumentValidity();">
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
      
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.DueDate' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp1" [formControl]="PaymentDueDate" [(ngModel)]="CurrentPurchaseContract.PaymentDueDate" (dateChange)="TestDocumentValidity();">
                      <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                      <mat-datepicker #dp1></mat-datepicker>
                    </mat-form-field>
              </div>
      
              <div class="newPurchaseContractInputContainer" style="width: 15%;">
                  <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.Currency' | translate }}</mat-label>
                      <mat-select name="currency" [compareWith]="compareFn" [(ngModel)]="currency">
                        <mat-option *ngFor="let c of this.Currencies" [value]="c" (click)="GetCurrencyLiveExchange(c);">
                          {{c.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                    <div class="PurchaseContractSelectedCurrency" *ngIf="currency != null && currency.ExchangeRate > 0;">
                      <mat-form-field class="example-full-width PurchaseContractExchangeInput">
                          <mat-label>{{ 'PurchaseContracts.ExchangeRate' | translate }}</mat-label>
                          <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
                          <input [(ngModel)]="currency.ExchangeRate" matInput placeholder="Exchange">
                        </mat-form-field>
                    </div>
              </div>
          </div>
  
          <div class="NewPurchaseContractBodyRow">
              <div class="PartnerSearchContainer">
                  
              </div>
      
              <div class="newPurchaseContractInputContainer" style="width: 15%;">
                
              </div>
      
              <div class="newPurchaseContractInputContainer" style="width: 15%;">
               
              </div>
      
              <div class="newPurchaseContractInputContainer">
                  <mat-form-field appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.StockEntryDate' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp2" [formControl]="StockEntryDate" [(ngModel)]="CurrentPurchaseContract.StockEntryDate" (dateChange)="TestDocumentValidity();">
                      <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                      <mat-datepicker #dp2></mat-datepicker>
                    </mat-form-field>
              </div>
      
              <div class="newPurchaseContractInputContainer" style="width: 15%;">
                  <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.DecimalPercision' | translate }}</mat-label>
                      <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="PurchaseContractPrecision">
                        <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="AdjustProductsDecimalPrecisionPrice();">
                          {{p.Meaning}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
              </div>
          </div>
  
          <div class="PurchaseContractProductsContainer">
              <div class="PurchaseContractProductsRow" style="padding-top: 10px;border: none;">
                  <div class="PurchaseContractProductsCol" style="width: 15%;">
                      <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline" *ngIf="NewProduct.ID == null;">
                          <mat-label>{{ 'PurchaseContracts.Administration' | translate }}</mat-label>
                          <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Administration">
                            <mat-option *ngFor="let a of this.Administrations;" [value]="a" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="SearchProductsPurchaseContractInformation(NewProduct.ProductPurchaseContractInfo.Name, a.ID, false);">
                              {{a.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch" *ngIf="NewProduct.ID != null;">
                          <mat-label>{{ 'PurchaseContracts.Administration' | translate }}</mat-label>
                          <input disabled="disabled" matInput placeholder="{{ 'PurchaseContracts.Administration' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Administration.Name">
                        </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;">
                      <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                          <mat-label>{{ 'PurchaseContracts.Table.Name' | translate }}</mat-label>
                          <input (click)="SearchProductsPurchaseContractInformation(NewProduct.ProductPurchaseContractInfo.Name, NewProduct.ProductPurchaseContractInfo.Administration.ID, false); showhideSearches(false);" matInput placeholder="{{ 'PurchaseContracts.Table.Name' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsPurchaseContractInformation(NewProduct.ProductPurchaseContractInfo.Name, NewProduct.ProductPurchaseContractInfo.Administration.ID, false);" (keydown.enter)="SelectPurchaseContractProductFromSearch(ProductsSearchResults[0]);">
                          <mat-icon matSuffix style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNT == 0 && !loadingSearchProducts && NewProduct.ProductPurchaseContractInfo.Name.length == 0;">search</mat-icon>
                          <mat-icon matSuffix style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNT > 0 || NewProduct.ProductPurchaseContractInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</mat-icon>
                        </mat-form-field>
                        <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
                          <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
                        </div>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                          <mat-label>{{ 'PurchaseContracts.Table.Code' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'PurchaseContracts.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Code" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsPurchaseContractInformation(NewProduct.ProductPurchaseContractInfo.Code, NewProduct.ProductPurchaseContractInfo.Administration.ID, false);">
                        </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                          <mat-label>{{ 'PurchaseContracts.Table.MU' | translate }}</mat-label>
                          <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.MeasuringUnit">
                            <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u" (selectionChange)="chanveNewProductVALUE($event);">
                              {{u.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                          <mat-label>{{ 'PurchaseContracts.Table.Qty' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'PurchaseContracts.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Quantity" (ngModelChange)="chanveNewProductVALUE($event);">
                        </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch">
                          <mat-label>{{ 'PurchaseContracts.Table.DocQty' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'PurchaseContracts.Table.DocQty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.DocQuantity" (ngModelChange)="chanveNewProductVALUE($event);">
                        </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch" *ngIf="!NewProductPriceContainsVAT">
                          <mat-label>{{ 'PurchaseContracts.Table.Price' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'PurchaseContracts.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice);">
                        </mat-form-field>
  
                        <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch" *ngIf="NewProductPriceContainsVAT">
                          <mat-label>{{ 'PurchaseContracts.Table.Price' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'PurchaseContracts.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice);">
                        </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                    <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.Table.VAT' | translate }}</mat-label>
                      <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductPurchaseContractInfo.Price.VAT">
                        <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="chanveNewProductVALUE($event);">
                          {{v.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 15%;">
                    <button [disabled]="!IsValidNewProduct" mat-raised-button color="primary" class="PurchaseContractProductsAddButton" (click)="AddProductToPurchaseContract();">
                      <i class="material-icons">add</i>
                      <span>{{ 'PurchaseContracts.Table.AddToPurchaseContract' | translate }}</span>
                  </button>
                  </div>
  
                  <div class="ProductsSearchResultsContainer" *ngIf="ProductsSearchResultsCOUNT > 0 && this.showSearch;">
                    <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResults" (click)="SelectPurchaseContractProductFromSearch(p);" [ngClass]="{'SearchResultPoolProductAlert': p.IsFromPool}">
                      <p class="ProductSearchResultTitle">{{p.Name}} 
                        <span *ngIf="p.DiscrepancyAmmount != null;" class="DiscrepancyAmmountSpan" [ngClass]="{'MinusDiscrepancyAmmount': p.DiscrepancyAmmount < 0, 'NormalDiscrepancyAmmount': p.DiscrepancyAmmount >= 0}">{{p.DiscrepancyAmmount}}
                          <span *ngIf="p.DiscrepancyAmmount < 0;"> {{'MissingStockValue' | translate}}</span>
                          <span *ngIf="p.DiscrepancyAmmount >= 0;"> {{'StockValue' | translate}}</span>
                        </span>
                      </p>
                      <p class="ProductSearchResultType">[{{p.Code}}] [{{p.GeneralType.Name}}] <span *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</span></p>
                    </div>
                  </div>
  
              </div>
  
              <div class="PurchaseContractProductsRow" style="height: 50px;border: none;">
                  <div class="PurchaseContractProductsCol" style="width: 15%;margin-top: 5px;">
                      <mat-slide-toggle [(ngModel)]="NewProductPriceContainsVAT"(change)="priceContainsVATchanged($event);">{{ 'PurchaseContracts.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 15%;text-align: left;padding-left: 1%;">
                    <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline" *ngIf="NewProduct.ID == null;">
                      <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                      <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.GeneralType">
                        <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                          {{t.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                    <mat-form-field appearance="outline" class="PurchaseContractProductsColSearch" *ngIf="NewProduct.ID != null;">
                      <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                      <input disabled="disabled" matInput placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.GeneralType.Name">
                    </mat-form-field>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 20%;">
                    
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 5%;">
                     
                  </div>
                  <div class="PurchaseContractProductsCol">
                     
                  </div>
                  <div class="PurchaseContractProductsCol">
                     
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 5%;">
                    
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 5%;">
                     
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 5%;">
                     
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 5%;">
                    
                  </div>
              </div>
  
              <div class="PurchaseContractProductsHeadder PurchaseContractProductsRow" style="border: none;">
                  <div class="PurchaseContractProductsCol">
                      {{ 'PurchaseContracts.Table.Nr' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      {{ 'PurchaseContracts.Administration' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                      {{ 'PurchaseContracts.Table.Name' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      {{ 'PurchaseContracts.Table.Code' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      {{ 'PurchaseContracts.Table.MU' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      {{ 'PurchaseContracts.Table.Qty' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      {{ 'PurchaseContracts.Table.DocQty' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      {{ 'PurchaseContracts.Table.Price' | translate }}  ({{currency.Name}})
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      {{ 'PurchaseContracts.Table.Total' | translate }} ({{currency.Name}})
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                      {{ 'PurchaseContracts.Table.VAT' | translate }}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                    
                  </div>
              </div>
  
              <div [ngClass]="{'NewProductAlertColor': p.ID == null || p.ID == 0, 'PoolProductAlert': p.IsFromPool}" class="PurchaseContractProductsRow PurchaseContractProductsRowHover" *ngFor="let p of this.Products; let i=index;" (dblclick)="OpenPurchaseContractEditProduct(p.ProductPurchaseContractInfo.UIID);CurrentIndexProduct = i;">
                <div class="PurchaseContractProductsCol">
                    {{i + 1}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                    <p>{{p.ProductPurchaseContractInfo.Administration.Name}}</p>
                    <p class="NewProductAlert" *ngIf="p.ID == null || p.ID == 0;">[{{'NewProduct' | translate}}]</p>
                    <p class="PoolProductAlertRow" *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</p>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                  <p>{{p.ProductPurchaseContractInfo.Name}}</p>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  <p>{{p.ProductPurchaseContractInfo.Code}}</p>
                  <p class="PurchaseContractProductsColDesc">{{p.ProductPurchaseContractInfo.GeneralType.Name}}</p>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{p.ProductPurchaseContractInfo.MeasuringUnit.Name}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{p.ProductPurchaseContractInfo.Quantity}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  {{p.ProductPurchaseContractInfo.DocQuantity}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                  <span *ngIf="p.ProductPurchaseContractInfo.Price.Discount == null || p.ProductPurchaseContractInfo.Price.Discount.Value == null">{{p.ProductPurchaseContractInfo.Price.UIUnitPrice}}</span>
                  <span *ngIf="p.ProductPurchaseContractInfo.Price.Discount != null && p.ProductPurchaseContractInfo.Price.Discount.Value != null">{{p.ProductPurchaseContractInfo.Price.UIUnitPriceDiscount}}</span>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                  <span *ngIf="p.ProductPurchaseContractInfo.Price.Discount == null || p.ProductPurchaseContractInfo.Price.Discount.Value == null">{{p.ProductPurchaseContractInfo.Price.UIQtyPrice}}</span>
                  <span *ngIf="p.ProductPurchaseContractInfo.Price.Discount != null && p.ProductPurchaseContractInfo.Price.Discount.Value != null">{{p.ProductPurchaseContractInfo.Price.UIQtyPriceDiscount}}</span>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  <span>{{p.ProductPurchaseContractInfo.Price.TotalVATValue}}</span>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                  <i class="material-icons PurchaseContractProductEdit" (click)="OpenPurchaseContractEditProduct(p.ProductPurchaseContractInfo.UIID);CurrentIndexProduct = i;">edit</i>
                  <div class="PurchaseContractProductEdit" (click)="OpenProductDiscountContainer(p);" *ngIf="CurrentPurchaseContract.Total.Discount != undefined && CurrentPurchaseContract.Total.Discount.Value == null;">%</div>
                  <i class="material-icons PurchaseContractProductEdit" style="color: red;" (click)="DeleteAuxProduct(p.ProductPurchaseContractInfo.UIID);TestDocumentValidity();">close</i>
                </div>
  
                <div class="ProductDiscountRow" *ngIf="p.ProductPurchaseContractInfo.Price.Discount != null && p.ProductPurchaseContractInfo.Price.Discount.Value != null">
                    <p>
                      Discount - {{p.ProductPurchaseContractInfo.Price.Discount.Value}}
                      <span *ngIf="p.ProductPurchaseContractInfo.Price.Discount.Type.ID == 1;">%</span>
                      <span *ngIf="p.ProductPurchaseContractInfo.Price.Discount.Type.ID == 2;">{{currency.Name}}</span>
                    </p>
                </div>
  
            </div>
  
            <div class="PurchaseContractProductsRow PurchaseContractProductsRowHover TotalRow" *ngIf="this.Products.length;">
              <div class="PurchaseContractProductsCol">
                 
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                  
              </div>
              <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
               
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                Total:
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{this.CurrentPurchaseContract.Total.TotalQtyPriceNOVAT}}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                {{this.CurrentPurchaseContract.Total.TotalVAT}}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 7.5%;">
                {{this.CurrentPurchaseContract.Total.TotalQtyPriceVAT}}
              </div>
          </div>
  
          <div class="PurchaseContractProductsRow PurchaseContractProductsRowHover TotalRow" *ngIf="this.Products.length;">
            <div class="PurchaseContractProductsCol">
               
            </div>
            <div class="PurchaseContractProductsCol" style="width: 10%;">
              <button mat-button color="warn" (click)="EliminateDocumentDiscount();" *ngIf="CurrentPurchaseContract.Total.Discount != null && CurrentPurchaseContract.Total.Discount.Value != null">
                <i class="material-icons buttonIcon">close</i>
                {{ 'PurchaseContracts.EliminateDiscount' | translate }}
               </button>
            </div>
            <div class="PurchaseContractProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
              
            </div>
            <div class="PurchaseContractProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="PurchaseContractProductsCol" style="width: 7.5%;">
             
            </div>
            <div class="PurchaseContractProductsCol" style="width: 15%;">
              
            </div>
            <div class="PurchaseContractProductsCol" style="width: 10%;">
              <div class="ProductGeneralDiscountRow" *ngIf="CurrentPurchaseContract.Total.Discount != null && CurrentPurchaseContract.Total.Discount.Value != null">
                <p style="padding-top: 0px;line-height: 35px;overflow: hidden;">
                  Discount - {{CurrentPurchaseContract.Total.Discount.Value}}
                  <span *ngIf="CurrentPurchaseContract.Total.Discount.Type.ID == 1;">%</span>
                  <span *ngIf="CurrentPurchaseContract.Total.Discount.Type.ID == 2;">{{currency.Name}}</span>
                </p>
            </div>
            </div>
            <div class="PurchaseContractProductsCol" style="width: 25%;text-align: right;padding-right: 10px;">
              <button mat-button color="primary" (click)="OpenDocumentDiscountContainer();">{{ 'PurchaseContracts.DocDiscount' | translate }} %</button>
            </div>
        </div>
  
          </div>
  
          <div class="PurchaseContractBottomCommands">
            <div class="BottomCommandsOverlay" *ngIf="!ValidDocument;"></div>
            <div class="PopUpBodyRowContainer">
              <div class="PopUpBodyOneThirddContainer">
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaPurchaseContract">
                    <mat-label>{{ 'PurchaseContracts.Mentions' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentPurchaseContract.Details.Observations"></textarea>
                  </mat-form-field>
                </div>
  
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaPurchaseContract">
                    <mat-label>{{ 'PurchaseContracts.InternalCommentary' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentPurchaseContract.Details.InternalCommentary"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div class="PopUpBodyOneThirddContainer">
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaPurchaseContract">
                    <mat-label>{{ 'PurchaseContracts.PurchaseContractComittee' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentPurchaseContract.Details.PurchaseContractCommittee"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div class="PopUpBodyOneThirddContainer">
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaPurchaseContract">
                    <mat-label>{{ 'PurchaseContracts.Delegate' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentPurchaseContract.Details.Delegate"></textarea>
                  </mat-form-field>
                </div>
  
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaPurchaseContract">
                    <mat-label>{{ 'PurchaseContracts.Auto' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentPurchaseContract.Details.Auto"></textarea>
                  </mat-form-field>
                </div>

                <div class="PopUpBodyRowContainer" *ngIf="CurrentPurchaseContract.ID != null;">
                  <form [formGroup]="newBlogForm" style="width: auto;float: left;">
                    <div style="margin-bottom: 10px;">
                        <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" style="width: 80%;">
                    </div>
                  </form>
                </div>
                <div class="PopUpBodyRowContainer" *ngIf="selectedFile != null;">
                  <button mat-raised-button color="accent" (click)="UploadPurchaseContractFile();">
                    <i class="material-icons">upload_file</i>
                    {{'UploadFile' | translate}}
                  </button>
                </div>
                <div class="PopUpBodyRowContainer" *ngIf="CurrentPurchaseContract.ID != null && CurrentPurchaseContract.FilePath != null;">
                  <button mat-button color="primary" (click)="DownloadFile(CurrentPurchaseContract);">
                    <i class="material-icons">download</i>
                    {{'DownloadFile' | translate}}
                  </button>
                </div>
                <div class="PopUpBodyRowContainer" *ngIf="CurrentPurchaseContract.ID != null && CurrentPurchaseContract.FilePath != null;">
                  <button mat-button color="warn" (click)="OpenDeleteFileQuestion();">
                    <i class="material-icons">delete_forever</i>
                    {{'DeleteFile' | translate}}
                  </button>
                </div>

              </div>
            </div>
            <div class="PopUpBodyRowContainer" *ngIf="!this.HasInitialPayments">
              <button mat-raised-button color="primary" class="SavePurchaseContractButton" (click)="AddPurchaseContract();" *ngIf="CurrentPurchaseContract.ID == null;">
                 <span *ngIf="!IsStorno;">{{ 'PurchaseContracts.SavePurchaseContract' | translate }}</span>
                 <span *ngIf="IsStorno;">{{ 'PurchaseContracts.StornoPurchaseContract' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>
             
              <button mat-raised-button color="primary" class="SavePurchaseContractButton" (click)="UpdatePurchaseContract();" *ngIf="CurrentPurchaseContract.ID != null;">
                <span *ngIf="!IsStorno;">{{ 'PurchaseContracts.UpdatePurchaseContract' | translate }}</span>
                <span *ngIf="IsStorno;">{{ 'PurchaseContracts.ModifyStorno' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>
            </div>

            <div class="PopUpBodyRowContainer" style="margin-top: 20px;">

              <button mat-raised-button color="primary" class="SavePurchaseContractButton" (click)="AddPurchaseContractWithReception();" *ngIf="CurrentPurchaseContract.ID == null && this.HasInitialPayments;">
                <span *ngIf="!IsStorno;">{{ 'AddPurchaseContractPlusReception' | translate }}</span>
                <span *ngIf="IsStorno;">{{ 'AddPurchaseContractPlusReception' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>
           
            </div>
          </div>
      </div>
  </div>